const apiAxiosSettings = {
    baseURL: process.env.VUE_APP_API_BASE_URL,
    withCredentials: true
};
export { apiAxiosSettings };
